// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__yJ4bJ","hero":"Section_hero__i9x6s","center":"Section_center__3JODN","fadeIn":"Section_fadeIn__1NBU_","scaleXin":"Section_scaleXin__3Gvoq"};